export enum MyProductRPricesSelectBaseEnum {
    // REJECTED = 'Abgelehnt',
    CUSTOM = 'Anderer Preis',
}
